import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Mutation, ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client/lib/main';
import qs from 'qs';

import ProfilePhoto from './ProfilePhoto';
import DriversLicense from './DriversLicense';
import Eligibility from './Eligibility';
import SubmitDocs from './SubmitDocs';
import UploadSuccess from './UploadSucess';
import './index.css';

const httpLink = createUploadLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

class MissingDocs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
      driversLicenseImage: null,
      uberProfileImage: null,
      employmentEligibilityImage: null,
      docs: [],
      isDialogOpen: false,
    };
  }

  componentDidMount() {
    this.setQuery(this.checkToken);
  }

  setQuery = callback => {
    const { token, docs } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.setState({ token, docs: docs.split(',') }, callback);
  };

  handleChange = (image, file) => {
    this.setState({ [image]: file });
  };

  openDialog = () => this.setState({ isDialogOpen: true });
  closeDialog = () => this.setState({ isDialogOpen: false });

  checkToken = async () => {
    const { data: { magicToken } } = await client.query({
      query: MAGIC_TOKEN,
      variables: { token: this.state.token },
    });
    if (!magicToken.email) {
      this.setState({ token: null });
    }
  };

  isEverythingSubmitted = () => {
    const { docs, driversLicenseImage, employmentEligibilityImage, uberProfileImage } = this.state;
    if (docs.includes('profile') && uberProfileImage === null) return false;
    if (docs.includes('dl') && driversLicenseImage === null) return false;
    if (docs.includes('employ') && employmentEligibilityImage === null) return false;
    return true;
  };

  render() {
    const { docs, driversLicenseImage, employmentEligibilityImage, isDialogOpen, token, uberProfileImage } = this.state;
    if (!token) return null;
    return (
      <ApolloProvider client={client}>
        <Mutation mutation={UPLOAD_PHOTO} onCompleted={e => console.log(e)}>
          {(uploadPhoto, { data, loading }) => (
            <div className="container">
              {docs.includes('profile') ? (
                <ProfilePhoto
                  handleChange={this.handleChange}
                  handleSubmit={uploadPhoto}
                  uberProfileImage={uberProfileImage}
                  imageType="uberProfileImage"
                  token={token}
                  images={data}
                  loading={loading}
                />
              ) : null}
              {docs.includes('dl') ? (
                <DriversLicense
                  handleChange={this.handleChange}
                  handleSubmit={uploadPhoto}
                  driversLicenseImage={driversLicenseImage}
                  imageType="driversLicenseImage"
                  token={token}
                  images={data}
                  loading={loading}
                />
              ) : null}
              {docs.includes('employ') ? (
                <Eligibility
                  handleChange={this.handleChange}
                  handleSubmit={uploadPhoto}
                  employmentEligibilityImage={employmentEligibilityImage}
                  imageType="employmentEligibilityImage"
                  token={token}
                  images={data}
                  loading={loading}
                />
              ) : null}
              <SubmitDocs token={token} openDialog={this.openDialog} disabled={!this.isEverythingSubmitted()} />
              <UploadSuccess isDialogOpen={isDialogOpen} closeDialog={this.closeDialog} />
            </div>
          )}
        </Mutation>
      </ApolloProvider>
    );
  }
}

const UPLOAD_PHOTO = gql`
  mutation uploadDocument($file: Upload!, $imageType: String!, $token: String!) {
    uploadDocument(file: $file, imageType: $imageType, token: $token) {
      user {
        uberProfileImage
        driversLicenseImage
        employmentEligibilityImage
      }
      errors {
        message
      }
    }
  }
`;

const MAGIC_TOKEN = gql`
  query magicToken($token: String!) {
    magicToken(token: $token) {
      email
    }
  }
`;

export default MissingDocs;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/index.js